import React, { useState } from 'react';
import CasinoCard from '../components/casino-card';
import casinos from '../data/casinos';

function Home() {
  const [openFaq, setOpenFaq] = useState(null);

  const featuredCasinos = casinos.filter(c => c.featured);
  const allCasinos = casinos;

  const faqs = [
    {
      q: 'Are the casinos listed on SlotsHub UK safe to play at?',
      a: 'Yes, all casinos featured on our site hold valid licences from the UK Gambling Commission. This means they meet strict regulatory standards for player protection, fair gaming, and responsible gambling practices.'
    },
    {
      q: 'How do you choose which casinos to recommend?',
      a: 'Our expert team evaluates casinos based on multiple factors including licensing, game variety, bonus terms, payment options, customer support quality, and player feedback. Only operators that meet our high standards are featured.'
    },
    {
      q: 'Do I need to pay to use SlotsHub UK?',
      a: 'No, our service is completely free. We earn commission from casinos when players sign up through our links, but this never affects our honest reviews or the bonuses you receive.'
    },
    {
      q: 'What should I do if I think I have a gambling problem?',
      a: 'If you\'re concerned about your gambling habits, please seek help immediately. Visit GambleAware.org, contact GamCare on 0808 8020 133, or register with GAMSTOP to self-exclude from all UK-licensed gambling sites.'
    },
    {
      q: 'How quickly can I withdraw my winnings?',
      a: 'Withdrawal times vary by casino and payment method. E-wallets typically process within 24 hours, while bank transfers may take 3-5 business days. Always check the specific casino\'s terms for accurate timeframes.'
    }
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-bg"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">
              <span className="badge-icon">🛡️</span>
              <span>100% UKGC Licensed Casinos</span>
            </div>
            <h1>Find Your Perfect <span className="highlight">UK Casino</span></h1>
            <p className="hero-subtitle">
              Compare the best licensed online casinos in the United Kingdom. 
              Expert reviews, exclusive bonuses, and safe gambling guaranteed.
            </p>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-value">9+</span>
                <span className="stat-label">Verified Casinos</span>
              </div>
              <div className="stat">
                <span className="stat-value">100%</span>
                <span className="stat-label">UKGC Licensed</span>
              </div>
              <div className="stat">
                <span className="stat-value">24/7</span>
                <span className="stat-label">Expert Support</span>
              </div>
            </div>
            <div className="hero-cta">
              <a href="#casinos" className="btn btn-primary btn-large">View Top Casinos</a>
              <a href="/how-we-review" className="btn btn-outline">How We Review</a>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Strip */}
      <section className="trust-strip">
        <div className="container">
          <div className="trust-content">
            <a href="https://www.gamblingcommission.gov.uk/" target="_blank" rel="noopener noreferrer" className="trust-item">
              <img src="/logos/ukgc.webp" alt="UK Gambling Commission" />
              <span>UKGC Licensed</span>
            </a>
            <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer" className="trust-item">
              <img src="/logos/begambleaware.svg" alt="BeGambleAware" />
              <span>BeGambleAware</span>
            </a>
            <a href="https://www.gamstop.co.uk/" target="_blank" rel="noopener noreferrer" className="trust-item">
              <img src="/logos/gamstop.jpg" alt="GAMSTOP" />
              <span>GAMSTOP Partners</span>
            </a>
            <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer" className="trust-item">
              <img src="/logos/gamcare.svg" alt="GamCare" />
              <span>GamCare Certified</span>
            </a>
          </div>
        </div>
      </section>

      <section className="urgent-disclaimer-strip">
        <div className="container">
          <div className="urgent-disclaimer-content">
            <span className="urgent-label">Important Player Notice</span>
            <p>
              This content is for adults aged 18+ only. Gambling involves risk and should never be used to solve financial problems.
              Please use GAMSTOP and safer gambling tools whenever needed.
            </p>
          </div>
        </div>
      </section>

      <section className="editorial-disclosure">
        <div className="container">
          <div className="editorial-disclosure-card">
            <h3>Independent UK Casino Information</h3>
            <p>We provide independent reviews of UK-licensed online casinos.</p>
            <p>All content is for informational purposes only.</p>
            <p>We do not offer gambling services or process payments.</p>
            <p><strong>18+ only. Gamble responsibly.</strong></p>
          </div>
        </div>
      </section>

      {/* Featured Casinos */}
      <section className="featured-section">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">⭐ Editor's Choice</span>
            <h2>Top Rated Casinos for April 2026</h2>
            <p>Hand-picked by our experts for outstanding quality, generous bonuses, and player satisfaction</p>
          </div>
          <div className="featured-grid">
            {featuredCasinos.map((casino, index) => (
              <CasinoCard key={casino.id} casino={casino} rank={index + 1} />
            ))}
          </div>
        </div>
      </section>

      {/* All Casinos */}
      <section className="casinos-section" id="casinos">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">🎰 Full Selection</span>
            <h2>All Recommended UK Casinos</h2>
            <p>Every casino on our list is licensed, verified, and trusted by thousands of UK players</p>
          </div>
          <div className="casinos-grid">
            {allCasinos.map((casino, index) => (
              <CasinoCard key={casino.id} casino={casino} rank={index + 1} />
            ))}
          </div>
        </div>
      </section>

      {/* Bonus Highlight */}
      <section className="bonus-section">
        <div className="container">
          <div className="bonus-card">
            <div className="bonus-content">
              <span className="bonus-badge">🎁 April Special</span>
              <h2>Exclusive Welcome Bonuses</h2>
              <p>
                Get access to the best welcome offers from top UK casinos. 
                Free spins, deposit matches, and no-wagering deals updated daily.
              </p>
              <ul className="bonus-features">
                <li>✓ Verified bonus codes</li>
                <li>✓ Fair wagering requirements</li>
                <li>✓ No hidden terms</li>
                <li>✓ Exclusive SlotsHub deals</li>
              </ul>
              <a href="#casinos" className="btn btn-primary">Claim Your Bonus</a>
            </div>
            <div className="bonus-visual">
              <div className="bonus-showcase">
                <div className="showcase-item">
                  <span className="showcase-value">100%</span>
                  <span className="showcase-label">Match Bonus</span>
                </div>
                <div className="showcase-item highlight">
                  <span className="showcase-value">50+</span>
                  <span className="showcase-label">Free Spins</span>
                </div>
                <div className="showcase-item">
                  <span className="showcase-value">£100</span>
                  <span className="showcase-label">Max Bonus</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="age-limit-banner">
        <div className="container">
          <div className="age-limit-card">
            <div className="age-limit-mark">18+</div>
            <div className="age-limit-text">
              <h3>Strict Age Restriction & Safer Gambling Reminder</h3>
              <p>
                You must be 18 or over to use any gambling service in the UK. If gambling is causing stress,
                stop now and contact GamCare or BeGambleAware for free confidential support.
              </p>
            </div>
            <a href="/responsible-gambling" className="btn btn-secondary">Get Immediate Support</a>
          </div>
        </div>
      </section>

      {/* How We Review */}
      <section className="review-process-section">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">🔍 Our Process</span>
            <h2>How We Review Casinos</h2>
            <p>Rigorous evaluation ensures only the best make our list</p>
          </div>
          <div className="process-grid">
            <div className="process-card">
              <div className="process-icon">🛡️</div>
              <h3>Licence Verification</h3>
              <p>We verify every casino holds a valid UK Gambling Commission licence before consideration.</p>
            </div>
            <div className="process-card">
              <div className="process-icon">🎮</div>
              <h3>Game Testing</h3>
              <p>Our team tests games, software providers, and overall platform quality extensively.</p>
            </div>
            <div className="process-card">
              <div className="process-icon">💳</div>
              <h3>Payment Analysis</h3>
              <p>We evaluate deposit/withdrawal options, processing times, and fee structures.</p>
            </div>
            <div className="process-card">
              <div className="process-icon">📞</div>
              <h3>Support Testing</h3>
              <p>Customer service is tested across multiple channels to ensure quality assistance.</p>
            </div>
            <div className="process-card">
              <div className="process-icon">📋</div>
              <h3>Terms Review</h3>
              <p>Bonus terms, wagering requirements, and fine print are carefully analysed.</p>
            </div>
            <div className="process-card">
              <div className="process-icon">⭐</div>
              <h3>Player Feedback</h3>
              <p>Real player reviews and experiences factor into our final recommendations.</p>
            </div>
          </div>
          <div className="section-cta">
            <a href="/how-we-review" className="btn btn-secondary">Learn More About Our Process</a>
          </div>
        </div>
      </section>

      {/* Why Licensed Sites */}
      <section className="why-licensed-section">
        <div className="container">
          <div className="why-licensed-content">
            <div className="why-licensed-text">
              <span className="section-badge">🇬🇧 UK Players</span>
              <h2>Why Play at Licensed UK Casinos?</h2>
              <p>
                Playing at UKGC-licensed casinos isn't just about following rules – it's about 
                protecting yourself and ensuring a fair gaming experience.
              </p>
              <ul className="benefits-list">
                <li>
                  <span className="benefit-icon">✓</span>
                  <div>
                    <strong>Player Fund Protection</strong>
                    <p>Your money is kept separate from operating funds</p>
                  </div>
                </li>
                <li>
                  <span className="benefit-icon">✓</span>
                  <div>
                    <strong>Fair Game Certification</strong>
                    <p>All games tested by independent auditors</p>
                  </div>
                </li>
                <li>
                  <span className="benefit-icon">✓</span>
                  <div>
                    <strong>Self-Exclusion Options</strong>
                    <p>Access to GAMSTOP and other tools</p>
                  </div>
                </li>
                <li>
                  <span className="benefit-icon">✓</span>
                  <div>
                    <strong>Dispute Resolution</strong>
                    <p>Independent arbitration if issues arise</p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="why-licensed-visual">
              <div className="licence-card">
                <img src="/logos/ukgc.webp" alt="UK Gambling Commission" />
                <h4>UK Gambling Commission</h4>
                <p>The gold standard in gambling regulation. Every casino we recommend is fully licensed.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Responsible Gambling */}
      <section className="responsible-section">
        <div className="container">
          <div className="responsible-card">
            <div className="responsible-header">
              <span className="age-badge-xl">18+</span>
              <div>
                <h2>Play Responsibly</h2>
                <p>Gambling should be fun, not a way to make money</p>
              </div>
            </div>
            <div className="responsible-content">
              <div className="responsible-tips">
                <h4>Safe Gambling Tips:</h4>
                <ul>
                  <li>Set a budget before you play and stick to it</li>
                  <li>Never chase losses or bet more than you can afford</li>
                  <li>Take regular breaks and don't gamble when upset</li>
                  <li>Use deposit limits and reality check tools</li>
                </ul>
              </div>
              <div className="responsible-help">
                <h4>Need Support?</h4>
                <div className="help-links">
                  <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer" className="help-link">
                    <img src="/logos/begambleaware.svg" alt="BeGambleAware" />
                  </a>
                  <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer" className="help-link">
                    <img src="/logos/gamcare.svg" alt="GamCare" />
                  </a>
                  <a href="https://www.gamstop.co.uk/" target="_blank" rel="noopener noreferrer" className="help-link">
                    <img src="/logos/gamstop.jpg" alt="GAMSTOP" />
                  </a>
                </div>
                <p className="helpline">National Gambling Helpline: <strong>0808 8020 133</strong></p>
              </div>
            </div>
            <a href="/responsible-gambling" className="btn btn-outline">Learn More About Responsible Gambling</a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="faq-section">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">❓ FAQ</span>
            <h2>Frequently Asked Questions</h2>
            <p>Got questions? We've got answers</p>
          </div>
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className={`faq-item ${openFaq === index ? 'open' : ''}`}
                onClick={() => setOpenFaq(openFaq === index ? null : index)}
              >
                <div className="faq-question">
                  <h4>{faq.q}</h4>
                  <span className="faq-toggle">{openFaq === index ? '−' : '+'}</span>
                </div>
                {openFaq === index && (
                  <div className="faq-answer">
                    <p>{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
